import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { string, object } from "prop-types";

import { DefaultFooter } from "./DefaultFooter";

import "./renderFooterComponents.m.css";

const RenderFooter = ({ domainSlug }) => {
  const [renderFooter, setRenderFooter] = useState(null);

  useEffect(() => {
    setRenderFooter(true);
  }, []);

  if (!renderFooter) {
    return false;
  }

  return <React.Fragment><div styleName="footer-warper"><DefaultFooter domainSlug={domainSlug} /></div></React.Fragment>;
};

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"], null),
});

RenderFooter.propTypes = {
  domainSlug: string,
};

export default connect(mapStateToProps, () => ({}))(RenderFooter);
